module.exports = __webpack_public_path__ + "static/img/noticia11.2b02c5e3.jpg";